import React from 'react';
import { LoadingIndicator } from '@milanote/roma';
import BoardLinkList from './BoardLinkList';
import { useTranslator } from '../../../i18n/useTranslator';
import { BoardLinkSearchItem } from './boardLinkTypes';

type BoardLinkListContentProps = {
    onSelect: (item: BoardLinkSearchItem) => boolean;
    gridSize: number;
    items: BoardLinkSearchItem[];
    isLoading: boolean;
    hasError: boolean;
    isEmpty: boolean;
    size: 'sm' | 'lg';
};

const BoardLinkListContent: React.FC<BoardLinkListContentProps> = ({
    onSelect,
    gridSize,
    items,
    isLoading,
    hasError,
    isEmpty,
    size,
}) => {
    const translate = useTranslator('popup', 'boardLink.state');

    if (isLoading) {
        return (
            <div
                className="BoardLinkListPopupLoading flex items-center justify-center py-4"
                aria-label="Loading link boards"
            >
                <LoadingIndicator.Spinner />
            </div>
        );
    }

    if (hasError) return <div className="px-3 py-4 text-center text-secondary">{translate('error')}</div>;
    if (isEmpty) return <div className="px-3 py-4 text-center text-secondary">{translate('empty')}</div>;

    return <BoardLinkList items={items} gridSize={gridSize} onSelect={onSelect} size={size} />;
};

export default BoardLinkListContent;
